var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7498 22.9167C20.96 22.9167 23.0796 22.0387 24.6424 20.4759C26.2052 18.9131 27.0832 16.7935 27.0832 14.5833C27.0832 12.3732 26.2052 10.2536 24.6424 8.69078C23.0796 7.12797 20.96 6.25 18.7498 6.25C16.5397 6.25 14.4201 7.12797 12.8573 8.69078C11.2945 10.2536 10.4165 12.3732 10.4165 14.5833C10.4165 16.7935 11.2945 18.9131 12.8573 20.4759C14.4201 22.0387 16.5397 22.9167 18.7498 22.9167V22.9167Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 43.75V39.5833C6.25 37.3732 7.12797 35.2536 8.69078 33.6908C10.2536 32.128 12.3732 31.25 14.5833 31.25H22.9167C25.1268 31.25 27.2464 32.128 28.8092 33.6908C30.372 35.2536 31.25 37.3732 31.25 39.5833V43.75",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 6.5271C35.126 6.98606 36.7148 8.02856 37.8494 9.49025C38.984 10.9519 39.5998 12.7497 39.5998 14.6C39.5998 16.4504 38.984 18.2481 37.8494 19.7098C36.7148 21.1715 35.126 22.214 33.3335 22.6729",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 43.7458V39.5792C43.7394 37.7399 43.1207 35.9558 41.9901 34.505C40.8596 33.0542 39.2809 32.0181 37.5 31.5583",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.ee3a45a2c478de52af2c33c7458f2fa2.svg";
export { ForwardRef as ReactComponent };